<template>
  <div class="paySucpage">
    <!-- 顶部图标 -->
    <div class="space-top">
      <img src="@/assets/error@2x.png" alt="" @click="comeback()">
      <p>E会员</p>
    </div>
    <div class="codeBox">
      <div class="qryCode">
        <img :src="wxurl" alt=""></div>
    </div>
    <p class="gongxi">恭喜您已购买成功！</p>
    <div class="baocun">长按保存二维码添加专属客服</div>
    <div class="baocun">得到E会员超级福利群</div>
    <p class="btn">
      <a :href="wxurl" download="zhulong_code">保存二维码</a>
    </p>
  </div>
</template>

<script>
import { payOver } from '@/api/epay'
export default {
  data() {
    return {
      wxurl: '',
      fromurl: ''
    }
  },
  created() {
    this.getFun()
  },
  methods: {
    // 返回上一页
    comeback() {
      this.$router.go(-1)
    },
    getFun() {
      const dataInfo = {
        fromurl: ''
      }
      payOver(dataInfo).then(res => {
        if (res.errNo !== 0) {
          console.log(res)
          return
        }
        console.log(res)
        this.wxurl = res.result.url
      })
    }
  }
}
</script>

<style lang='less' scoped>
// 个人顶部图标
  .space-top {
    background: #f2f2f2;
    width: 100%;
    padding: 0 28px 0 28px;
    box-sizing: border-box;
    height: 86px;
    position: fixed;
    top: 0px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    z-index: 10;
    img {
      width: 45px;
    }
    p{
      font-size: 35px;
      color: #000;
      margin-left: 238px;
    }
  }
.codeBox{
    margin-top: 174px;
    padding-top: 110px;
}
.qryCode{
    width: 290px;
    height: 290px;
    // background-color: pink;
    margin: 0 auto
}
.qryCode img{
    width: 100%;
    height: 100%;
}
.gongxi{
    text-align: center;
    font-size: 40px;
    color: #333;
    margin-bottom: 40px;
    margin-top: 72px;
    font-weight: 400;
}
.baocun{
    font-size: 28px;
    margin-bottom: 24px;
    text-align: center;
    color: #333;
}
.btn{
    width: 252px;
    height: 74px;
    background: #ee2e2e;
    color: #fff;
    font-size: 28px;
    line-height: 74px;
    text-align: center;
    margin: 60px auto;
    border-radius: 10px ;
    overflow: hidden;
    a{
      display: inline-block;
      width: 100%;
      height: 100%;
    }
}
</style>
